// @ts-check
import React from "react";
import PropTypes from "prop-types";
import { Small, Flex } from "orcs-design-system";

/**
 * @returns {React.ReactElement}
 */
export const AIWarning = ({ justifyContent = "center", mb = "0" }) => {
  return (
    // @ts-ignore
    <Flex
      flex="1 1 auto"
      alignItems="center"
      mb={mb}
      justifyContent={justifyContent}
    >
      <Small color="greyDark" fontSize="0">
        <em>This is AI-generated content. Be sure to fact-check.</em>
      </Small>
    </Flex>
  );
};

AIWarning.propTypes = {
  justifyContent: PropTypes.string,
  mb: PropTypes.string,
};
